import { render, staticRenderFns } from "./SelectorCantidadRegistros.vue?vue&type=template&id=ba8a32c4&scoped=true&"
import script from "./SelectorCantidadRegistros.vue?vue&type=script&lang=js&"
export * from "./SelectorCantidadRegistros.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ba8a32c4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src1477836768/src/github.com/FebosIO/Febos-AMI/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ba8a32c4')) {
      api.createRecord('ba8a32c4', component.options)
    } else {
      api.reload('ba8a32c4', component.options)
    }
    module.hot.accept("./SelectorCantidadRegistros.vue?vue&type=template&id=ba8a32c4&scoped=true&", function () {
      api.rerender('ba8a32c4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/febos/chile/dte/componentes/SelectorCantidadRegistros.vue"
export default component.exports